import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import SuperAdminNavbar from "../Components/Superadminnavbar";
import { FaDollarSign, FaUsers, FaExchangeAlt, FaEye } from "react-icons/fa";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useDataContext } from "../Context/dataContext";
import { NotFound } from "./NotFound";
import { toast } from "react-toastify";
import { FaCopy } from "react-icons/fa";

function Dashboard() {
  const { url, infoTkn } = useDataContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedHash, setSelectedHash] = useState("");
  const [isRejecting, setIsRejecting] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [errorHash, setErrorHash] = useState("");
  const [errorFile, setErrorFile] = useState("");


  const [admin, setAdmin] = useState([]);
  const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [currency, setCurrency] = useState([]);

  const [usdtToday, setUsdtToday] = useState(0);
  const [bsToday, setBsToday] = useState(0);

  const [currencyBs, setCurrencyBs] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const toggle = (data) => {
    setSelectedData(data);
    setShowModal(!showModal);
  };

  const fetchCurrencyBs = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/currency-price/1`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setCurrencyBs(response.data.cur_bs);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, url]);

  const fetchCurrency = async () => {
    try {
      const response = await axios.get(
        "https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=eur"
      );
      setCurrency(response.data.tether.eur);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchUsdtToday = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/Movements/total/totalUsdtPaid`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setUsdtToday(response.data);
    } catch (error) {
      console.error(error);
    }
  }, [infoTkn, url]);

  const fetchBsToday = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/Movements/total/totalBsPaid`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setBsToday(response.data);
    } catch (error) {
      console.error(error);
    }
  }, [infoTkn, url]);

  const handleSend = async (event) => {
    event.preventDefault();
    setErrorHash("");
    setErrorFile("");

    // Validar que el hash no esté vacío si es USDT
    if (selectedData.mov_conversionType === "Usdt" && !selectedHash.trim()) {
      setErrorHash("El hash no puede estar vacío.");
      return;
    }

    // Validar que el comprobante no esté vacío si es Bolívares
    if (selectedData.mov_conversionType === "Bs" && !selectedFile) {
      setErrorFile("Debes adjuntar un comprobante de pago.");
      return;
    }

    try {
      const formData = new FormData();
      selectedData.mov_conversionType === "Bs"
        ? formData.append("mov_paymentProof", selectedFile)
        : formData.append("mov_paymentProof", selectedHash);

      formData.append("mov_paymentDate", getFormattedDate());
      selectedData.mov_conversionType === "Bs"
        ? formData.append(
          "mov_paymentAmount",
          (selectedData.mov_amount /
            (currency * selectedData.User.Admin.adm_porcent + currency)) *
          currencyBs
        )
        : formData.append(
          "mov_paymentAmount",
          selectedData.mov_amount /
          (currency * selectedData.User.Admin.adm_porcent + currency)
        );
      formData.append("mov_status", "V");

      await axios.put(
        `${url}/Movements/payment/${selectedData.mov_id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );

      window.location.reload();
    } catch (error) {
      console.error("Error al enviar la transacción:", error);
    }

    setModalOpen(false);
  };


  const handleRejectClick = () => {
    setIsRejecting(true); // Activa el cuadro de texto
  };

  const handleCancelReject = () => {
    setIsRejecting(false);
    setRejectReason("");
  };

  const getFormattedDate = () => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    return new Date().toLocaleDateString("es-ES", options);
  };

  const handleReject = async (event) => {
    event.preventDefault();

    try {
      const formData = new FormData();
      formData.append("mov_paymentComment", rejectReason);
      formData.append("mov_status", "R");

      await axios.put(
        `${url}/Movements/payment/${selectedData.mov_id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );

      window.location.reload();
    } catch (error) { }

    setModalOpen(false);
  };

  const openModal = (data) => {
    setSelectedData(data);
    setModalOpen(true);
  };

  const fetchDataAdmin = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/Auth/findByJWTSuperAdmin/${infoTkn}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setAdmin(response.data.data);

      const responseAdmins = await axios.get(`${url}/Admin`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setUsers(responseAdmins.data);

      const responseMovements = await axios.get(`${url}/Movements/allByAdmin`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setOrders(responseMovements.data);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, setAdmin, url]);

  useEffect(() => {
    fetchDataAdmin();
    fetchCurrency();
    fetchUsdtToday();
    fetchBsToday();
    fetchCurrencyBs();
  }, [fetchDataAdmin, fetchUsdtToday, fetchBsToday, fetchCurrencyBs]);

  return admin ? (
    <div>
      <SuperAdminNavbar />
      <div className="dashboard">
        {/* Tarjetas de Totales */}
        <div className="stats-container">
          {/* Tarjeta Total USD */}
          <div className="stat-card blue">
            <FaDollarSign className="stat-icon" />
            <h3>USDT Cambiados</h3>
            <p>{usdtToday.total ? usdtToday.total.toFixed(2) : 0} Usdt</p>
            <span className="subtext">Transacciones del día</span>
          </div>

          {/* Tarjeta Total Euros */}
          <div className="stat-card green">
            <FaDollarSign className="stat-icon" />
            <h3>Euros Cambiados</h3>
            <p>{bsToday.total ? bsToday.total.toFixed(2) : 0} Bs</p>
            <span className="subtext">Transacciones del día</span>
          </div>

          {/* Tarjeta Tasa Oficial */}
          <div className="stat-card purple">
            <FaExchangeAlt className="stat-icon" />
            <h3>Tasa Oficial</h3>
            <p>1 USDT = Bs. {currencyBs}</p>
            <span className="subtext">Referencia del mercado</span>
          </div>

          {/* Tarjeta Total Administradores */}
          <div
            className="stat-card orange"
            onClick={() => (window.location.href = "/UsersAdmins")}
          >
            <FaUsers className="stat-icon" />
            <h3>Administradores</h3>
            <p>{users.length}</p>
            <span className="subtext">Gestión de Administradores</span>
          </div>
        </div>

        {/* Tabla de Transacciones Pendientes */}
        <div className="transactions-table">
          <h3>📌 Transacciones Pendientes</h3>
          <table className="orders-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Usuario</th>
                <th>Monto en Euros</th>
                <th>Comprobante</th>
                <th>Monto en USD/BS</th>
                <th>Tasa Oficial</th>
                <th>Estado</th>
                <th>Datos</th>
              </tr>
            </thead>
            <tbody>
              {orders
                .filter((order) => order.mov_status === "P")
                .reverse()
                .map((transaction, index) => (
                  <tr key={index}>
                    <td>{transaction.mov_id}</td>
                    <td>
                      {transaction.User.use_name}{" "}
                      {transaction.User.use_lastName}
                    </td>
                    <td>{transaction.mov_amount}</td>
                    <td>
                      <button
                        className="btn-view"
                        onClick={() => {
                          toggle();
                          setSelectedData(transaction);
                        }}
                      >
                        <FaEye /> Ver
                      </button>
                    </td>
                    {transaction.mov_conversionType === "Usdt" && (
                      <td>
                        {(
                          transaction.mov_amount /
                          (currency * transaction.User.Admin.adm_porcent +
                            currency)
                        ).toFixed(2)}
                      </td>
                    )}
                    {transaction.mov_conversionType === "Bs" && (
                      <td>
                        {(
                          (transaction.mov_amount /
                            (currency * transaction.User.Admin.adm_porcent +
                              currency)) *
                          currencyBs
                        ).toFixed(2)}
                      </td>
                    )}
                    {transaction.mov_conversionType === "Usdt" && (
                      <td> 1 Eur = {currency} Usdt</td>
                    )}
                    {transaction.mov_conversionType === "Bs" && (
                      <td> 1 Usdt = {currencyBs} Bs</td>
                    )}
                    <td className={`status`}>
                      {transaction.mov_status === "P"
                        ? "En Espera"
                        : transaction.mov_status === "R"
                          ? "Rechazado"
                          : "Aprobado"}
                    </td>
                    <td>
                      <button
                        className="view-data-btn"
                        onClick={() => openModal(transaction)}
                      >
                        <FaEye />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <Modal isOpen={showModal} centered toggle={toggle}>
  <ModalHeader toggle={toggle}>Comprobante de Pago</ModalHeader>
  <ModalBody className="modal-body-responsive">
    <img
      src={`${url}/Movements/proof/${selectedData.mov_proof}`}
      alt="Comprobante de Pago"
      className="proof-image"
    />
  </ModalBody>
</Modal>


        {/* Modal de Datos */}
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} centered>
  <ModalHeader toggle={() => setModalOpen(false)}>
    Datos de la Transferencia
  </ModalHeader>
  <ModalBody className="modal-body-responsive">
    {selectedData.mov_conversionType === "Bs" && (
      <p
        dangerouslySetInnerHTML={{
          __html:
            selectedData &&
            selectedData.mov_comment.replace(/\n/g, "<br/>"),
        }}
      />
    )}

    {isRejecting ? (
      <div className="reject-section">
        <label htmlFor="reject-reason">Motivo del rechazo:</label>
        <textarea
          id="reject-reason"
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
          placeholder="Escribe el motivo aquí..."
        />
      </div>
    ) : (
      <>
        {selectedData.mov_conversionType === "Bs" && (
          <div className="file-upload">
            <label htmlFor="file">Adjuntar Comprobante:</label>
            <input
              type="file"
              id="file"
              onChange={(e) => setSelectedFile(e.target.files[0])}
            />
            {errorFile && <p className="error-message">{errorFile}</p>}
          </div>
        )}
       {selectedData.mov_conversionType === "Usdt" && (
  <div className="file-upload">
    <label htmlFor="hash">Datos Admin:</label>
    <p>
      <strong>Nombre:</strong> {selectedData.User?.Admin?.adm_name}{" "}
      {selectedData.User?.Admin?.adm_lastName}
      <br />
      <strong>Wallet:</strong>{" "}
      <span className="wallet-text">
        {selectedData.User?.Admin?.adm_wallet
          ? `${selectedData.User.Admin.adm_wallet.slice(0, 6)}...${selectedData.User.Admin.adm_wallet.slice(-4)}`
          : "No disponible"}
      </span>
      {selectedData.User?.Admin?.adm_wallet && (
        <button
          className="copy-btn"
          onClick={() => {
            navigator.clipboard.writeText(selectedData.User.Admin.adm_wallet);
            toast.success("Wallet copiada al portapapeles");
          }}
        >
          <FaCopy />
        </button>
      )}
    </p>

    <label htmlFor="hash">Hash:</label>
    <input
      type="text"
      id="hash"
      value={selectedHash}
      onChange={(e) => setSelectedHash(e.target.value)}
    />
    {errorHash && <p className="error-message">{errorHash}</p>}
  </div>
)}
      </>
    )}
  </ModalBody>
  <ModalFooter>
    {isRejecting ? (
      <>
        <Button color="secondary" onClick={handleCancelReject}>
          Cancelar
        </Button>
        <Button
          color="danger"
          onClick={handleReject}
          disabled={!rejectReason}
        >
          Enviar
        </Button>
      </>
    ) : (
      <>
        <Button color="danger" onClick={handleRejectClick}>
          Rechazar
        </Button>
        <Button color="success" onClick={handleSend}>
          Enviar
        </Button>
      </>
    )}
  </ModalFooter>
</Modal>

      </div>
    </div>
  ) : (
    <NotFound />
  );
}

export { Dashboard };
